/** @format */

import SettingState from './type';

const InitialSettingState: SettingState = {
    sidebarShow: 'responsive',
};

export default InitialSettingState;
